export default __webpack_public_path__ + "static/media/logo.93483d14.png";